import { faBirthdayCake, faChevronLeft } from "@fortawesome/pro-light-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import {
  FamilyChildProfile,
  JoonUIColor,
  ModalHeader,
  Typography,
} from "@joonapp/web-shared"
import dayjs from "dayjs"

import { getCurrentAge } from "../../../util/dates"
import useSurveysModalStore from "../store/useSurveysModalStore"

const Survey = () => {
  const { selectedChildSurveys, selectedProfile, onClose, clearSurvey } =
    useSurveysModalStore()

  if (!selectedChildSurveys || !selectedProfile) return null

  const childProfile = selectedProfile as FamilyChildProfile

  return (
    <>
      <ModalHeader
        onClose={onClose}
        title={
          (
            <div className="flex flex-row gap-3 items-center">
              <button onClick={clearSurvey}>
                <FontAwesomeIcon
                  icon={faChevronLeft}
                  color={JoonUIColor.icon.neutral}
                  fontSize={16}
                />
              </button>
              <Typography variant="h4">Survey details</Typography>
            </div>
          ) as any
        }
        showBorderBottom
      />
      <div className="flex flex-row px-6 py-4 bg-bgXLightGray border-b border-borderPrimary justify-between items-center">
        <Typography variant="bodyBold">
          {selectedProfile?.user.name}{" "}
          {childProfile?.user.birthdate &&
            `(${getCurrentAge(childProfile?.user.birthdate)})`}
        </Typography>
        <div className="flex flex-row items-center gap-2">
          {childProfile.user.birthdate && (
            <div className="flex flex-row items-center gap-2 border-r border-borderPrimary pr-2">
              <FontAwesomeIcon
                icon={faBirthdayCake}
                color={JoonUIColor.icon.accent}
                fontSize={14}
              />
              <Typography variant="bodySmall">
                {dayjs(childProfile?.user.birthdate).format("MMM D, YYYY")}
              </Typography>
            </div>
          )}
          {childProfile?.user.gender && (
            <Typography variant="bodySmall">
              {childProfile?.user.gender}
            </Typography>
          )}
        </div>
      </div>

      <div className="flex flex-col gap-4 overflow-y-auto">
        {selectedChildSurveys.map((survey, index) => (
          <>
            <div
              className={`flex flex-row px-6 py-4 justify-between items-center flex-wrap bg-bgXLightGray border-b ${
                index !== 0 ? "border-t" : ""
              } border-borderPrimary`}
            >
              <Typography variant="bodyBold">
                {survey.questionnaire.display_name}
              </Typography>
              <Typography
                variant="bodyXSmall"
                color={JoonUIColor.text.secondary}
              >
                Completed on{" "}
                {dayjs(survey.date_submitted).format("MMM D, YYYY")}
              </Typography>
            </div>
            <div className="flex flex-col gap-4 px-6 mb-6">
              {survey.answers.map((answer, index) => (
                <div key={index} className="flex flex-col gap-1">
                  <Typography variant="body">
                    {answer.question.question}
                  </Typography>
                  {answer.answers.length > 0 ? (
                    answer.answers.map((answer) => (
                      <div className="p-3 bg-bgLightGray rounded-md border border-borderPrimary">
                        <Typography variant="bodySmall">
                          {answer.answer}
                        </Typography>
                      </div>
                    ))
                  ) : answer.freeform_answer ? (
                    <div className="p-3 bg-bgLightGray rounded-md border border-borderPrimary">
                      <Typography variant="bodySmall">
                        {answer.freeform_answer}
                      </Typography>
                    </div>
                  ) : (
                    <div className="p-3 bg-bgLightGray rounded-md border border-borderPrimary">
                      <Typography variant="bodySmall">No answer</Typography>
                    </div>
                  )}
                </div>
              ))}
            </div>
          </>
        ))}
      </div>
    </>
  )
}

export default Survey
